<template>
  <div class="vv-category-card" @click="$emit('click')" v-bind:class="variantClass">
        <div class="vv-category-card-img" :style="setBackgroundImg" v-bind:class="imgVariantClass">
        </div>
        <div class="vv-category-card-title" v-bind:class="containerVariantClass">
            <span class="title">{{ titleCapitalizeAll }}</span>
        </div>
  </div>
</template>

<script>
export default {
  name: "VvCategoryCard",
  props: {
    img: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    variant: {
      type: String
    }
  },
  computed: {
    setBackgroundImg() {
      return { 'background-image': `url('${require(`@/assets/${this.img}`)}')` };
    },
    variantClass() {
      return this.variant ? `card-${this.variant}`: ''
    },
    imgVariantClass() {
      return this.variant ? `img-${this.variant}`: ''
    },
    containerVariantClass() {
      return this.variant ? `container-${this.variant}`: ''
    },
    titleCapitalizeAll() {
      return this.title.split(' ').map((word) => { 
        return word[0].toUpperCase() + word.substring(1)
      }).join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.vv-category-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 350px;
  box-shadow: 0px 0px 10px 0px #b3b2b2;
  -webkit-box-shadow: 0px 0px 10px 0px #b3b2b2;
  -moz-box-shadow: 0px 0px 10px 0px #b3b2b2;
  overflow: hidden;
  margin: 0px 40px 40px 40px;
  border-radius: 15px;
  background-color: white;
  color: $primary;
  transition: all 0.1s ease-in;

  @media screen and (max-width: 1271px) {
    width: 40%;
    min-width: 290px;
    margin-right: 10px;
    margin-left: 10px;
  }

  @media screen and (max-width: 450px) {
    min-width: 100%;
    margin-left: 0;
    margin-right: 0;
    height: 300px;
  }

  &:hover {
    cursor: pointer;
    transform:scale(1.01);
    box-shadow: 0px 0px 10px 0px #8d8c8c;
    -webkit-box-shadow: 0px 0px 10px 0px #8d8c8c;
    -moz-box-shadow: 0px 0px 10px 0px #8d8c8c;
    background-color: $primary-alt;
    color: unset;
    fill: unset;
  }

}

.vv-category-card-img {
  height: 330px;
  width: 100%;
  background-size: cover;
  background-position: center;

  @media screen and (max-width: 1271px) {
    height: 250px;
  }
}

.vv-category-card-title {
  font-family: 'Helvetica', sans-serif;
  font-weight: bold;
  font-size: 20px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 80px;
  width: 100%;
}

</style>